import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    color: #e75480;
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      color: #e75480;
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    color: #e75480;
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    color: #e75480;
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    color: #e75480;
    margin-top: 15rem;
  }
  .about__info__item {
    color: #e75480;
    margin-bottom: 10rem;
  }
  .about__info__heading {
    color: #e75480;
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      color: #e75480;
      font-size: 1.8rem;
    }
    .about__heading {
      color: #e75480;
      font-size: 2.8rem;
    }
    .about__info__heading {
      color: #e75480;
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Ciao, sono <span>Laura</span>
              </p>
              <h2 className="about__heading">Sono una Hair Styling</h2>
              <div className="about__info">
                <PText>
                  Sono originaria di Besnate, convivo e ho una splendida
                  bambina. Fin da piccola mi è sempre piaciuta la creatività, la
                  quale si può, esprimere in molti modi. il mio motto è "la
                  bellezza dei tuoi capelli non è una questione di prezzo ma di
                  qualità"
                  <br /> <br />
                  Metto al servizio dei clienti tutto l'impegno e la
                  professionalità, valori che negli anni si sono plasmati
                  insieme alla passione, ai valori della mia collaboratrice,
                  alla ricerca continua di tutto ciò che è bello, di tutto ciò
                  che ispira e di tutto ciò che è arte
                  <br />
                  <br />
                  Credo fortemente nei valori della condivisione, del confronto
                  e nell'arte che da questi ne viene fuori. Concediti del tempo
                  e vienimi a trovare.
                </PText>
              </div>
              <Button btnText="Home" btnLink="" />
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Orari Negozio</h1>

              <AboutInfoItem title="Domenica" items={['Chiuso']} />
              <AboutInfoItem title="Lunedì" items={['Chiuso']} />

              <AboutInfoItem
                title="Martedì"
                items={['9.00 - 18.00 Orario continuato']}
              />
              <AboutInfoItem
                title="Mercoledì"
                items={['13.00 - 21.00 Orario continuato']}
              />
              <AboutInfoItem
                title="Giovedì"
                items={['9.00 - 18.00 Orario continuato']}
              />
              <AboutInfoItem
                title="Venerdì"
                items={['9.00 - 18.00 Orario continuato']}
              />
              <AboutInfoItem
                title="Sabato"
                items={['8.00 - 18.00 Orario Continuato']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">
                Qualcuno dei miei servizi con prezzi esemplificativi, vienici a
                trovare per maggiori dettagli
              </h1>

              <AboutInfoItem title="Piega" items={['da € 14']} />
              <AboutInfoItem title="Taglio" items={['da € 12']} />
              <AboutInfoItem title="Trattamento" items={['da € 20']} />
            </div>
            <div className="about__info__item" />
          </div>
        </div>
      </AboutPageStyles>
    </>
  );
}
